function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#999",
  fillRule: "evenodd",
  d: "M17.314 22.94c-1.075.067-1.99-.743-2.057-1.809-.066-1.065.738-1.986 1.812-2.053 1.062-.068 1.977.745 2.044 1.81.068 1.064-.739 1.984-1.8 2.052m17.814-2.872c-1.25-1.267-3.322-1.048-4.544.246-1.587 1.669-2.823 2.292-4.292 2.226-2.056-.088-3.069-1.675-4.124-3.68-1.098-2.095-2.78-3.26-4.881-3.26-3.301 0-5.286 2.676-5.286 5.658 0 4.59 3.227 7.334 5.462 8.492 1.856.965 3.922 1.37 5.76 1.414-.108 1.1-.432 2.547-.79 3.573h3.78c-.372-1.026-.703-2.591-.802-3.692 5.535-.719 8.164-3.235 9.605-5.629.644-1.05.99-2.14.985-3.12-.004-.857-.275-1.638-.873-2.228"
});

function SvgKyoboOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyoboOff);
export default __webpack_public_path__ + "static/media/kyobo-off.5d86b8df.svg";
export { ForwardRef as ReactComponent };